// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1adm0","left":"StickyBox_left__3IYLz","right":"StickyBox_right__3sv0H"};